import styled from '@emotion/styled';
import googleDriveLogo from './google-drive-logo.png';

const StyledIcon = styled('img')({
  width: 24,
  height: 24,
});

const GoogleDriveIcon = () => <StyledIcon src={googleDriveLogo} alt="" />;

export default GoogleDriveIcon;
